export const convertToMilitary = (date: Date): string => {
  const hours = date.getHours().toLocaleString().padStart(2, '0');
  const minutes = date.getMinutes().toLocaleString().padStart(2, '0');
  const timeString = `${hours}:${minutes}`;
  const dateString = date.toLocaleDateString();

  return `${dateString} ${timeString}Z`;
};

export const dayAfterDate = (d: Date): Date => {
  let dayAfter = new Date(d);
  dayAfter.setDate(d.getDate() + 1);
  return dayAfter;
};

export const dateFilter = (dateWasSet: boolean, date: { startDate: Date | null; endDate: Date | null }): string => {
  const { startDate, endDate } = date;
  startDate?.setHours(0);
  endDate?.setHours(0);
  if (dateWasSet && startDate && endDate) {
    return `CreatedDatetime ge ${startDate?.toISOString()} and CreatedDatetime lt ${dayAfterDate(endDate).toISOString()}`;
  } else {
    return '';
  }
};

export const formatDateForOData = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDate = (value: Date | string | undefined | null): string => {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString();
}